//=====================================================
//　症状テキストボックス
//=====================================================

import { useContext } from "react";
import { InputTag } from "../utils/ConstCommon";
import { getMsg, ConstMsg } from "../utils/ConstMsg";
import { CtxClinicInfo } from "../utils/Contexts";
import { InputTextBase } from "./InputTextBase";
import { LblInput } from "./LblInput";
import { ValidErrMsgInline } from "./ValidErrMsgInline";
import { FieldValues, useFormContext, UseFormReturn } from "react-hook-form";

interface IFProps {
    name: string,
}

const FORM_TITLE = "症状";

export function TxtSymptoms(props: IFProps) {

    const cci = useContext(CtxClinicInfo);
    const cf = useFormContext();

    //バリデーション
    const validations = {
        maxLength: {value: 100, message: getMsg(ConstMsg.EG0050001, [FORM_TITLE, "100"])},
        validate: {invalid: function(){return invalidCheck(props, cf)}}
    }

    return (
        <div className="input-box">
            <LblInput title={FORM_TITLE} tag={InputTag.Optional} />
            <ValidErrMsgInline name={props.name}/>
            <InputTextBase name={props.name} className="input-text-symptoms" validations={validations}/>
            <div className="input-supple text-multiline">
                {cci.data.comment.memoComment}
            </div>
        </div>
    )

}

//-----------------------------------------------------
//　入力不可チェック
//-----------------------------------------------------
function invalidCheck(props: IFProps, cf: UseFormReturn<FieldValues>){

    let value = cf.getValues(props.name);

    if ( value.match(/[\\"<>;'`]/) ){ 
        return ConstMsg.EG0110001;
    }
    return null;
}